import Reflux from 'reflux';

const ArchiveLicenseActions = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

export default ArchiveLicenseActions;
